import { cn } from '../cn';
import { Icon } from './Icon';

import type { IconName } from '../icons';
import type { HTMLAttributes } from 'react';

export type ToastTone = 'info' | 'success' | 'warning' | 'danger';

const TONE: Record<ToastTone, { icon: IconName; color: string }> = {
  info: { icon: 'info', color: 'var(--content-info-default)' },
  success: { icon: 'circle-check', color: 'var(--content-success-default)' },
  warning: { icon: 'triangle-alert', color: 'var(--content-warning-default)' },
  danger: { icon: 'circle-alert', color: 'var(--content-danger-default)' },
};

export interface ToastProps extends HTMLAttributes<HTMLDivElement> {
  tone?: ToastTone | undefined;
}

/** One toast. Positioning and timing belong to the host that renders it (Phase 2 ToastHost). */
export function Toast({ tone = 'info', className, children, ...rest }: ToastProps) {
  const t = TONE[tone];
  return (
    <div
      role="status"
      className={cn(
        'flex w-80 items-center gap-2.5 rounded-full bg-surface-action-neutral-default px-5 py-3 text-content-inversed shadow-7',
        className,
      )}
      {...rest}
    >
      <Icon name={t.icon} size={18} color={t.color} />
      <span className="ds-body-sm text-inherit">{children}</span>
    </div>
  );
}
